var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#ff2424;}.cls-4{fill:#ff4545;}.cls-5{fill:#f1f2f2;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tron"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_51",
    "data-name": "Layer 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    className: "cls-3",
    width: 30,
    height: 30,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    className: "cls-4",
    d: "M0,7A7,7,0,0,1,7,0h6.47a16.39,16.39,0,0,1,.81,5.1A16.32,16.32,0,0,1,0,21.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-5",
    d: "M8.46,7.63l.19,0,1.08.19,1.3.23,1.32.24,1.3.24,1.21.22L16.25,9l1.46.27,1.59.3.63.11a.87.87,0,0,1,.27.14l.54.49,1.81,1.74.32.3a.57.57,0,0,1,.19.49L23,13a2.9,2.9,0,0,1-.39.53l-2.39,2.93-2.82,3.43-2.44,3-.36.43a.47.47,0,0,1-.1.1.15.15,0,0,1-.2,0h0a.53.53,0,0,1-.12-.14l-.12-.32-1-2.45-2.4-5.77C10,12.82,9.18,11,8.45,9.14c-.12-.31-.24-.62-.35-.94a.43.43,0,0,1,.26-.56h.1Zm1.2,1.73h0l4.7,11.49a0,0,0,0,0,0,0l.08-.69c0-.24.05-.47.08-.71s.06-.47.08-.71L14.7,18l.09-.77.09-.78.09-.77c0-.28.06-.57.1-.85l.09-.78a.07.07,0,0,0,0-.06l-1.81-1.53L10,9.6Zm5.65,11.48h0l6.13-7.37h-.06l-.51.09-.95.15-1.05.17-1,.16-1,.16-.75.12s0,0,0,0l-.06.49-.09.7-.08.7c0,.24-.05.47-.08.7s0,.47-.08.7l-.09.7c0,.24-.05.47-.08.7l-.09.77-.09.78a1.79,1.79,0,0,1,0,.24Zm3.53-10.36L10.38,8.92h0l5.22,4.28Zm-2.05,2.89h0l4.81-.88-1.79-1.65Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTron);
export default __webpack_public_path__ + "static/media/tron.b050e026774d9e6692a6cf05f2fc67ff.svg";
export { ForwardRef as ReactComponent };